'use strict';

var SET_CRYPTOACCOUNT_STATE = 'SET_CRYPTOACCOUNT_STATE';

function _CryptoReducers() {
  var initialCryptoState = {};

  function updateCryptoStateObject(stateData, action) {
    return updateObject(stateData, action);
  }

  function cryptoReducer(state, action) {
    switch (action.type) {
      case SET_CRYPTOACCOUNT_STATE:
        return updateCryptoStateObject(state, action.payload);
      default:
        return state;
    }
  }

  this.cryptoReducer = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialCryptoState;
    var action = arguments[1];

    return cryptoReducer(state, action);
  };
}